export default "__VITE_ASSET__1dfb3c87__"